import localeReducer from 'reducers/locale';
import { createRootReducerFactory, injectReducerFactory } from '@Utilities/services/reducers';

export const createRootReducer = createRootReducerFactory({
  locale: localeReducer
});

export const injectReducer = injectReducerFactory(createRootReducer);

export default createRootReducer;
